// extracted by mini-css-extract-plugin
export default {"codeWrapper":"eGTK8m","topActionsContainer":"OFBxJ0","footerButtonsContainer":"G1uyCM","markdown-wrapper":"HxydY6","markdownWrapper":"HxydY6"};